import React from 'react';
import CopyableValue from '../common/CopyableValue';
import FitText from '../common/FitText';

const MainMetric = ({ label, value, subValue, rightElement, valueAlign = 'left' }) => (
  <div>
    <div className={`flex items-center gap-3 mb-1.5 ${valueAlign === 'right' ? 'justify-end' : ''}`}>
      <div className="text-primary-orange uppercase tracking-wider text-sm font-medium">{label}</div>
      {rightElement}
    </div>
    <div className="text-slate-300/90 font-bold text-4xl mb-1">
      <FitText align={valueAlign}>
        <CopyableValue
          value={value}
          label={label}
          preserveFormatting
          className={value === '--' || value === '--x' ? 'dashes' : ''}
          size="large"
          showTooltip={false}
          copyEnabled={valueAlign !== 'right'}
        >
          {value}
        </CopyableValue>
      </FitText>
    </div>
    <div className="text-slate-500 text-sm tracking-wide">
      <FitText align={valueAlign}>
        <CopyableValue
          value={subValue}
          label={`${label} (Sub)`}
          preserveFormatting
          className={subValue.includes('--') ? 'dashes' : ''}
          size="small"
          showTooltip={false}
          copyEnabled={valueAlign !== 'right'}
        >
          {subValue}
        </CopyableValue>
      </FitText>
    </div>
  </div>
);

export default MainMetric;
